import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const ControlsRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1rem 0;
`

export const ControlsSpacer = styled.div`
  flex: 1;
`

export const NotifList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-top: 0.5rem;
`

export const NotifRow = styled.div<{ $unread: boolean; $clickable: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  border-left: 3px solid ${({ $unread }) => ($unread ? tokens.accent.base : tokens.border.hairline)};
  background: ${({ $unread }) => ($unread ? tokens.surface.glass : 'transparent')};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: border-color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${({ $clickable }) => ($clickable ? tokens.accent.base : tokens.border.hairline)};
  }
`

export const SevDot = styled.span<{ $sev: 'high' | 'med' | 'low' }>`
  flex: none;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 100%;
  background: ${({ $sev }) =>
    $sev === 'high' ? tokens.status.danger.fg : $sev === 'med' ? tokens.status.warning.fg : tokens.status.info.fg};
`

export const NotifBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const NotifTitle = styled.span<{ $unread: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $unread }) => ($unread ? 700 : 500)};
  color: ${tokens.text.primary};
`

export const NotifDetail = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const NotifMeta = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const NotifSide = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const AckedTag = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.status.success.fg};
  white-space: nowrap;
`

export const EmptyState = styled.div`
  padding: 2.5rem 0;
  text-align: center;
  color: ${tokens.text.muted};
`

export const UnreadSummary = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`
